import { Compass, LifeBuoy } from "lucide-react";
import { Link } from "react-router";

import { usePageTitle } from "../lib/hooks";
import { EmptyState } from "../ui/Notice";

export function NotFoundPage() {
  usePageTitle("Page not found");
  return (
    <div className="card">
      <EmptyState
        icon={<Compass size={20} />}
        title="Page not found"
        action={
          <Link to="/" className="btn btn-primary">
            <LifeBuoy size={16} aria-hidden="true" />
            Go to the help page
          </Link>
        }
      >
        It may have moved, or the link may be wrong.
      </EmptyState>
    </div>
  );
}
